/*
  The mobile filter panel, built to the mockup Bed approved on 9 Oct 2026.
  (claude.ai/code/artifact/ddc99b62-b47d-43a0-b0d0-faf62fbefe1f)

  MOBILE ONLY. Everything here is gated on `(max-width: 989px)` and scoped to
  `.mobile-facets`; the desktop filter column is `#main-collection-filters` and
  is never touched.

  WHY JAVASCRIPT AND NOT LIQUID. The panel lives in snippets/facets.liquid,
  which is 49,618 bytes — past the 16KB cap on a theme push, so it cannot be
  edited at all. Everything below is therefore done to the markup the theme
  already prints, after it prints it.

  WHAT IT CHANGES
    · A facet holding one value is not a filter. Product Type holds only
      "Indian Dress" (1,137 of 1,137) and Discount holds one value; both are
      rows that cannot change anything. They are removed.
    · Every remaining facet states how many values it holds, so a shopper can
      tell Crafts (24) from Style (4) without opening it.
    · The five that matter open where they are, capped at eight values with a
      way to the rest — picking a craft was three taps and is now one.
    · Sort appears ON the panel. It is called "Filter and sort" and the sort
      control was a select nobody saw.
    · The button says what pressing it will give you.
*/
(function () {
  'use strict';

  var WIDE = '(min-width: 990px)';
  var OPEN_BY_DEFAULT = ['price', 'craft', 'material', 'occasion', 'colour', 'color'];
  var CAP = 8;
  /* The theme's nine sort options, in the shop's words rather than Shopify's:
     "Alphabetically, A-Z" twice over is three lines of chips for something
     nobody sorts a dress rail by. Five, named short. */
  var SORT_LABELS = {
    'manual': 'Featured',
    'best-selling': 'Best selling',
    'created-descending': 'New in',
    'price-ascending': 'Price \u2191',
    'price-descending': 'Price \u2193'
  };

  function name(det) {
    var s = det.querySelector('summary');
    return s ? s.innerText.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function values(det) {
    return det.querySelectorAll('.mobile-facets__list > li');
  }

  function build(panel) {
    if (!panel || panel.dataset.sjfDone === '1') return;
    if (window.matchMedia(WIDE).matches) return;
    panel.dataset.sjfDone = '1';

    var main = panel.querySelector('.mobile-facets__main');

    /* Sort, as chips, at the top — from the theme's own select, so the
       options and the submit path stay the theme's. */
    var sel = panel.querySelector('#SortBy-mobile');
    if (sel && main && !main.querySelector('.sjf-sort')) {
      var wrap = document.createElement('div');
      wrap.className = 'sjf-sort';
      var lab = document.createElement('p');
      lab.className = 'sjf-h';
      lab.textContent = 'SORT';
      wrap.appendChild(lab);
      var row = document.createElement('div');
      row.className = 'sjf-chips';
      Array.prototype.filter.call(sel.options, function (o) {
        return Object.prototype.hasOwnProperty.call(SORT_LABELS, o.value);
      }).forEach(function (o) {
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'sjf-chip' + (o.selected ? ' is-on' : '');
        c.textContent = SORT_LABELS[o.value];
        c.addEventListener('click', function () {
          sel.value = o.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        row.appendChild(c);
      });
      wrap.appendChild(row);
      main.insertBefore(wrap, main.firstChild);
    }

    /* Each facet: drop the useless ones, state the rest, open the five that
       carry the page, and cap the long lists. */
    Array.prototype.forEach.call(
      panel.querySelectorAll('details.mobile-facets__details'),
      function (det) {
        var n = name(det);
        var vals = values(det);
        var isPrice = n.indexOf('price') === 0;

        if (!isPrice && vals.length <= 1) {
          det.hidden = true;
          return;
        }

        var sum = det.querySelector('summary');
        if (sum && !sum.querySelector('.sjf-n') && !isPrice) {
          var tag = document.createElement('em');
          tag.className = 'sjf-n';
          tag.textContent = String(vals.length);
          sum.appendChild(tag);
        }

        if (OPEN_BY_DEFAULT.some(function (k) { return n.indexOf(k) === 0; })) {
          det.setAttribute('open', '');
          det.classList.add('sjf-open');
        }

        if (vals.length > CAP) {
          det.classList.add('sjf-capped');
          if (!det.querySelector('.sjf-more')) {
            var more = document.createElement('button');
            more.type = 'button';
            more.className = 'sjf-more';
            more.textContent = 'Show all ' + vals.length;
            more.addEventListener('click', function () {
              var all = det.classList.toggle('sjf-all');
              more.textContent = all ? 'Show fewer' : 'Show all ' + vals.length;
            });
            var list = det.querySelector('.mobile-facets__list');
            if (list && list.parentNode) list.parentNode.insertBefore(more, list.nextSibling);
          }
        }
      }
    );

    /* The button says what you get. The count is the theme's own, so it stays
       right as the choices change. */
    label(panel);
  }

  function label(panel) {
    var src = document.querySelector('.product-count__text, .mobile-facets__count');
    var n = src ? (src.innerText.match(/[\d,]+/) || [])[0] : '';
    Array.prototype.forEach.call(
      panel.querySelectorAll('.mobile-facets__footer .mobile-facets__close-button, .mobile-facets__footer button'),
      function (b) {
        if (/remove|clear/i.test(b.innerText)) return;
        b.classList.add('sjf-apply');
        if (n) b.textContent = 'SHOW ' + n + ' PIECES';
      }
    );
  }

  /* THE PAGE HAS TO SCROLL AGAIN AFTERWARDS.

     Dawn locks the page with `overflow-hidden-mobile`, not `overflow-hidden`
     — measured: body carried `overflow-hidden-mobile` and `overflow: hidden`
     both while the drawer was open AND after it closed, because the class
     being removed was one that was never added. The page then could not be
     scrolled by touch at all. Bed: "after opening and closing the filter on
     mobile i am unable to scroill".

     All three are cleared, because which one the theme uses depends on the
     breakpoint it thinks it is at. */
  function unlock() {
    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet'
    );
  }

  function closer(panel) {
    var head = panel.querySelector('.mobile-facets__header-inner');
    if (!head || head.querySelector('[data-sjf-close]')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sjf-close';
    b.setAttribute('data-sjf-close', '');
    b.setAttribute('aria-label', 'Close filters');
    b.innerHTML = '&times;';
    head.appendChild(b);
  }

  document.addEventListener('click', function (e) {
    var x = e.target.closest ? e.target.closest('[data-sjf-close]') : null;
    if (x) {
      var d = x.closest('details');
      if (d) { d.classList.remove('menu-opening'); d.removeAttribute('open'); }
      unlock();
      return;
    }
    if (!e.target.closest) return;
    if (!e.target.closest('.mobile-facets__open-wrapper, .mobile-facets__open')) return;
    setTimeout(function () {
      var panel = document.querySelector('.mobile-facets');
      if (!panel) return;
      closer(panel);
      build(panel);
    }, 40);
  });

  /* The facet form replaces its own markup after every change, so the work
     has to be redone when it does. */
  var mo = new MutationObserver(function () {
    var panel = document.querySelector('.mobile-facets');
    /* NOT `&& panel.closest('details.menu-opening')`. The facet form replaces
       this markup after every change and the replacement comes back CLOSED, so
       that condition was false exactly when the work needed redoing — the sort
       chips, the capped lists and the close button were simply gone until the
       page was loaded again. Bed, 17 Oct 2026: "i have to refesh the page to
       get the proper filter page".

       Safe against the observer re-entering itself: build() sets sjfDone as
       its first statement, before it touches the DOM, so a callback triggered
       by its own mutations returns immediately. */
    if (panel && panel.dataset.sjfDone !== '1') {
      closer(panel);
      build(panel);
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
